import { z } from 'zod';

import { BorrowerAchAccountId, BorrowerId, LoanId } from '../BrandedIds';
import { zodDateOrString } from '../utils';

export const BorrowerAchAccount = z.object({
  id: BorrowerAchAccountId,
  borrowerId: BorrowerId,
  loanId: LoanId,
  accountName: z.string(),
  lastFour: z.string(),
  // True when the receiving account belongs to an entity or LLC rather than a
  // natural person — common on BP/construction loans, rare on residential.
  // NACHA Operating Rules require non-consumer receivers to use the CCD SEC
  // code, so this flag is what flips our payment paths off PPD/WEB onto CCD.
  isCorporateAccount: z.boolean(),
  prenoteSubmittedAt: zodDateOrString.optional(),
  disabledAt: zodDateOrString.optional(),
  addedByCompany: z.boolean(),
  createdAt: z.date(),
});
export type BorrowerAchAccount = z.infer<typeof BorrowerAchAccount>;
